module.exports = __webpack_public_path__ + "img/router.59a76461.svg";